<script setup lang="ts">
defineProps<{
  text: string
}>()
</script>

<template>
  <span class="bx-content bx-content__roofline bx-typo--content-roofline">
    {{ text }}
  </span>
</template>
